(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-pillow-form"] && !Shopify.designMode) return;
  try {
    
  const customPillowStandardSizeOptions = [
    { value: '16" X 16"', label: '16" X 16"' },
    { value: '18" X 18"', label: '18" X 18"' },
    { value: '20" X 20"', label: '20" X 20"' },
    { value: '22" X 22"', label: '22" X 22"' },
    { value: '24" X 24"', label: '24" X 24"' },
    { value: '26" X 26"', label: '26" X 26"' },
    { value: 'LITTLE LUMBAR 12" X 18"', label: 'LITTLE LUMBAR 12" X 18"' },
    { value: '14" X 24"', label: '14" X 24"' },
    { value: '14" X 30"', label: '14" X 30"' },
    { value: '14" X 36"', label: '14" X 36"' },
    { value: 'XL LUMBAR 14" X 48"', label: 'XL LUMBAR 14" X 48"' },
    { value: '15" X 22"', label: '15" X 22"' },
    { value: '20" X 26" STANDARD SHAM', label: '20" X 26" STANDARD SHAM' },
    { value: '20" X 30" QUEEN SHAM', label: '20" X 30" QUEEN SHAM' },
    { value: '20" X 36" KING SHAM', label: '20" X 36" KING SHAM' },
  ];
  const customPillowStandardOutdoorSizeOptions = [
    { value: '20" X 20"', label: '20" X 20"' },
    { value: '22" X 22"', label: '22" X 22"' },
    { value: 'LITTLE LUMBAR 12" X 18"', label: 'LITTLE LUMBAR 12" X 18"' },
    { value: '14" X 20" LUMBAR', label: '14" X 20" LUMBAR' },
  ];
  const customPillowBolsterSizeOptions = [
    { value: 'TWIN // 9" X 24"', label: 'TWIN // 9" X 24"' },
    { value: 'TWIN XL // 9" X 30"', label: 'TWIN XL // 9" X 30"' },
    { value: 'QUEEN // 9" X 36"', label: 'QUEEN // 9" X 36"' },
    { value: 'KING // 9" X 48"', label: 'KING // 9" X 48"' },
  ];
  const customPillowBolsterOutdoorSizeOptions = [
    { value: '7" X 16"', label: '7" X 16"' },
    { value: '7" X 20"', label: '7" X 20"' },
    { value: '7" X 24"', label: '7" X 24"' },
  ];
  const customPillowSkittleSizeOptions = [
    { value: '12"', label: '12"' },
    { value: '14"', label: '14"' },
    { value: '16"', label: '16"' },
    { value: '18"', label: '18"' },
  ];
  const customPillowEdgeFinishOptions = [
    { value: 'KNIFE EDGE ($65)', label: 'KNIFE EDGE ($65)' },
    { value: 'SELF CORD ($90)', label: 'SELF CORD ($90)' },
    { value: 'CONTRAST CORD ($90)', label: 'CONTRAST CORD ($90)' },
    { value: 'SELF BUTTERFLY ($90)', label: 'SELF BUTTERFLY ($90)' },
    { value: 'CONTRAST BUTTERFLY ($90)', label: 'CONTRAST BUTTERFLY ($90)' },
    { value: 'FRINGE / TASSEL ($90)', label: 'FRINGE / TASSEL ($90)' },
    { value: 'SELF MITER FLANGE ($90)', label: 'SELF MITER FLANGE ($90)' },
    { value: 'CONTRAST MITER FLANGE ($90)', label: 'CONTRAST MITER FLANGE ($90)' },
  ];
  const customPillowCustomEdgeFinishOptions = [
    { value: 'KNIFE EDGE ($75)', label: 'KNIFE EDGE ($75)' },
    { value: 'SELF CORD ($100)', label: 'SELF CORD ($100)' },
    { value: 'CONTRAST CORD ($100)', label: 'CONTRAST CORD ($100)' },
    { value: 'SELF BUTTERFLY ($100)', label: 'SELF BUTTERFLY ($100)' },
    { value: 'CONTRAST BUTTERFLY ($100)', label: 'CONTRAST BUTTERFLY ($100)' },
    { value: 'FRINGE / TASSEL ($100)', label: 'FRINGE / TASSEL ($100)' },
    { value: 'SELF MITER FLANGE ($100)', label: 'SELF MITER FLANGE ($100)' },
    { value: 'CONTRAST MITER FLANGE ($100)', label: 'CONTRAST MITER FLANGE ($100)' },
  ];
  const customPillowXlLumbarEdgeFinishOptions = [
    { value: 'KNIFE EDGE ($135)', label: 'KNIFE EDGE ($135)' },
    { value: 'SELF CORD ($160)', label: 'SELF CORD ($160)' },
    { value: 'CONTRAST CORD ($160)', label: 'CONTRAST CORD ($160)' },
    { value: 'SELF BUTTERFLY ($160)', label: 'SELF BUTTERFLY ($160)' },
    { value: 'CONTRAST BUTTERFLY ($160)', label: 'CONTRAST BUTTERFLY ($160)' },
  ];
  const customPillowBolsterEdgeFinishOptions = [
    { value: 'SELF CORD ', label: 'SELF CORD ' },
    { value: 'CONTRAST CORD ', label: 'CONTRAST CORD ' },
    { value: 'SELF RUFFLE ($45)', label: 'SELF RUFFLE ($45)' },
    { value: 'CONTRAST RUFFLE ($45)', label: 'CONTRAST RUFFLE ($45)' },
    { value: 'FRINGE ', label: 'FRINGE ' },
    { value: 'TASSEL ', label: 'TASSEL ' },
    { value: 'TASSLE FRINGE ', label: 'TASSLE FRINGE ' },
  ];
  const customPillowSkittleEdgeFinishOptions = [
    { value: 'KNIFE EDGE', label: 'KNIFE EDGE' },
    { value: 'SELF BOX BAND (+$25)', label: 'SELF BOX BAND (+$25)' },
    { value: 'CONTRAST BOX BAND (+$25)', label: 'CONTRAST BOX BAND (+$25)' },
  ];
  const customPillowTapeTrimOptions = [
    { value: 'NO TRIM', label: 'NO TRIM' },
    { value: 'CENTER TRIM [FRONT] (+$10)', label: 'CENTER TRIM [FRONT] (+$10)' },
    { value: 'CENTER TRIM [FRONT & BACK] (+$10)', label: 'CENTER TRIM [FRONT & BACK] (+$10)' },
    { value: 'PARALLEL TRIM [FRONT] (+$20)', label: 'PARALLEL TRIM [FRONT] (+$20)' },
    { value: 'PARALLEL TRIM [FRONT & BACK] (+$20)', label: 'PARALLEL TRIM [FRONT & BACK] (+$20)' },
  ];
  const customPillowBolsterTapeTrimOptions = [
    { value: 'NO TRIM', label: 'NO TRIM' },
    { value: 'CENTER TRIM (+$10)', label: 'CENTER TRIM (+$10)' },
    { value: 'PARALLEL TRIM [2 PIECES] (+$20)', label: 'PARALLEL TRIM [2 PIECES] (+$20)' },
  ];
  const customPillowInsertTypeOptions = [
    { value: 'FEATHER DOWN', label: 'FEATHER DOWN' },
    { value: 'DOWN ALTERNATIVE', label: 'DOWN ALTERNATIVE' },
  ];
  const customPillowXlLumbarInsertTypeOptions = [
    { value: 'DOWN ALTERNATIVE', label: 'DOWN ALTERNATIVE' },
  ];
  const customPillowBasePrices = {
    bolster: 135,
    'ball pillow': 105,
    skittle: 105,
    'xl lumbar': 135,
    'xl lumbar 14" x 48"': 135,
  };
  const customPillowFeatherDownInsertPricesBySize = {
    '20" X 20"': 49,
    '22" X 22"': 53,
    '24" X 24"': 59,
    '26" X 26"': 64,
    'LITTLE LUMBAR 12" X 18"': 33,
    '14" X 24"': 49,
    '14" X 30"': 55,
    '14" X 36"': 63,
    'XL LUMBAR 14" X 48"': 73,
    '15" X 22"': 45,
    '20" X 26" STANDARD SHAM': 59,
    '20" X 30" QUEEN SHAM': 64,
    '20" X 36" KING SHAM': 69,
  };
  const customPillowDownAlternativeInsertPricesBySize = {
    '20" X 20"': 53,
    '22" X 22"': 58,
    '24" X 24"': 63,
    '26" X 26"': 68,
    'LITTLE LUMBAR 12" X 18"': 28,
    '14" X 24"': 48,
    '14" X 30"': 58,
    '14" X 36"': 73,
    'XL LUMBAR 14" X 48"': 88,
    '15" X 22"': 48,
    '20" X 26" STANDARD SHAM': 68,
    '20" X 30" QUEEN SHAM': 88,
    '20" X 36" KING SHAM': 108,
  };

  const setCustomPillowSelectOptions = (select, placeholder, options, optionSet, force = false) => {
    const currentValue = select.value;

    if (!force && select.dataset.customPillowOptionSet === optionSet) return;

    select.innerHTML = '';

    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);

    options.forEach((option) => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value;
      optionElement.textContent = option.label;
      select.appendChild(optionElement);
    });

    select.dataset.customPillowOptionSet = optionSet;
    select.value = options.some((option) => option.value === currentValue) ? currentValue : '';
  };

  const toggleCustomPillowProductTypeFields = (item) => {
    const productTypeSelect = item.querySelector('[data-custom-pillow-product-type-select]');
    const productDetails = item.querySelector('[data-custom-pillow-product-details]');
    const sizeSelect = item.querySelector('[data-custom-pillow-size-select]');
    const sizeField = sizeSelect?.closest('.custom-pillow-form__field');
    const sizeLabel = item.querySelector('[data-custom-pillow-size-label]');
    const customHeightField = item.querySelector('[data-custom-pillow-custom-height-field]');
    const customWidthField = item.querySelector('[data-custom-pillow-custom-width-field]');
    const edgeFinishField = item.querySelector('[data-custom-pillow-edge-finish-field]');
    const edgeFinishSelect = item.querySelector('[data-custom-pillow-edge-finish-select]');
    const tapeTrimRow = item.querySelector('[data-custom-pillow-tape-trim-row]');
    const tapeTrimSelect = item.querySelector('[data-custom-pillow-tape-trim-select]');
    const standardIntendedUseField = item.querySelector('[data-custom-pillow-standard-intended-use-field]');
    const standardIntendedUseSelect = standardIntendedUseField?.querySelector('[data-custom-pillow-field]');
    const reverseFabricNameLabel = item.querySelector('[data-custom-pillow-reverse-fabric-name-label]');
    const reverseFabricNameField = item.querySelector('[data-custom-pillow-reverse-fabric-name-field]');
    const reverseFabricLinkLabel = item.querySelector('[data-custom-pillow-reverse-fabric-link-label]');
    const reverseFabricLinkField = item.querySelector('[data-custom-pillow-reverse-fabric-link-field]');
    const bolsterLengthField = item.querySelector('[data-custom-pillow-bolster-length-field]');
    const bolsterIntentedUseField = item.querySelector('[data-custom-pillow-bolster-intented-use-field]');
    const bolsterIntentedUseSelect = bolsterIntentedUseField?.querySelector('[data-custom-pillow-field]');
    const ottomanTypeField = item.querySelector('[data-custom-pillow-ottoman-type-field]');
    const ottomanTrimmingField = item.querySelector('[data-custom-pillow-ottoman-trimming-field]');
    const ottomanTrimmingSelect = ottomanTrimmingField?.querySelector('[data-custom-pillow-field]');
    const ottomanTrimmingFabricNameField = item.querySelector('[data-custom-pillow-ottoman-trimming-fabric-name-field]');
    const ottomanTrimmingFabricLinkField = item.querySelector('[data-custom-pillow-ottoman-trimming-fabric-link-field]');
    const bolsterDisclaimer = item.querySelector('[data-custom-pillow-bolster-disclaimer]');
    const ottomanDisclaimer = item.querySelector('[data-custom-pillow-ottoman-disclaimer]');
    const ballPillowDisclaimer = item.querySelector('[data-custom-pillow-ball-pillow-disclaimer]');
    const xlLumbarDisclaimer = item.querySelector('[data-custom-pillow-xl-lumbar-disclaimer]');
    const addInsertField = item.querySelector('[data-custom-pillow-add-insert-field]');
    const addInsertSelect = item.querySelector('[data-custom-pillow-add-insert-select]');
    const customInsertHint = item.querySelector('[data-custom-pillow-custom-insert-hint]');
    const insertTypeField = item.querySelector('[data-custom-pillow-insert-type-field]');
    const insertTypeSelect = item.querySelector('[data-custom-pillow-insert-type-select]');
    const boxBandRow = item.querySelector('[data-custom-pillow-box-band-row]');
    const boxBandSelect = item.querySelector('[data-custom-pillow-box-band-select]');
    const itemNotesField = item.querySelector('[data-custom-pillow-item-notes-field]');

    if (!productTypeSelect || !sizeSelect || !sizeLabel) return;

    const productTypeValue = (productTypeSelect.value || '').trim().toLowerCase();
    const productTypeChanged = item.dataset.customPillowProductType !== productTypeValue;
    const hasProductType = productTypeValue !== '';
    const isBolster = productTypeValue === 'bolster';
    const isOttoman = productTypeValue === 'ottoman';
    const isBallPillow = productTypeValue === 'ball pillow';
    const isSkittle = productTypeValue === 'skittle';
    const isXlLumbar = productTypeValue === 'xl lumbar' || productTypeValue === 'xl lumbar 14" x 48"';
    const isStandardPillow = productTypeValue === 'pillow' || productTypeValue === 'pillow (standard)' || productTypeValue === 'pillow (standard sizes)';
    const isCustomPillow = productTypeValue === 'pillow (custom)' || productTypeValue === 'pillow (custom sizes)';
    const standardIntendedUseValue = (standardIntendedUseSelect?.value || '').trim().toLowerCase();
    const isOutdoorPillow = (isStandardPillow || isCustomPillow) && standardIntendedUseValue === 'outdoor';
    const isPillowWithInsertOption = isStandardPillow || isCustomPillow;
    const isStandardXlLumbarSize = isStandardPillow && sizeSelect.value === 'XL LUMBAR 14" X 48"';

    item.dataset.customPillowProductType = productTypeValue;

    if (productDetails) {
      productDetails.style.display = hasProductType ? 'block' : 'none';
      productDetails.setAttribute('aria-hidden', hasProductType ? 'false' : 'true');

      productDetails.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !hasProductType;

        if (!hasProductType) {
          if (field.type === 'checkbox') {
            field.checked = false;
          } else if (field.dataset.fieldLabel === 'QUANTITY') {
            field.value = '1';
          } else {
            field.value = '';
          }
        }
      });
    }

    if (!hasProductType) {
      return false;
    }

    sizeLabel.textContent = 'SIZE';
    sizeSelect.dataset.fieldLabel = 'SIZE';

    if (reverseFabricNameLabel) {
      reverseFabricNameLabel.textContent = 'REVERSE FABRIC NAME & COLORWAY';
    }

    if (reverseFabricNameField) {
      reverseFabricNameField.dataset.fieldLabel = 'REVERSE FABRIC NAME & COLORWAY';
    }

    if (reverseFabricLinkLabel) {
      reverseFabricLinkLabel.textContent = 'REVERSE FABRIC LINK';
    }

    if (reverseFabricLinkField) {
      reverseFabricLinkField.dataset.fieldLabel = 'REVERSE FABRIC LINK';
    }

    if (sizeField) {
      sizeField.style.display = isOttoman || isBallPillow || isXlLumbar || isCustomPillow ? 'none' : 'block';
      sizeField.setAttribute('aria-hidden', isOttoman || isBallPillow || isXlLumbar || isCustomPillow ? 'true' : 'false');
    }

    sizeSelect.disabled = isOttoman || isBallPillow || isXlLumbar || isCustomPillow;

    if (isOttoman || isBallPillow || isXlLumbar || isCustomPillow) {
      sizeSelect.value = '';
    }

    [
      standardIntendedUseField,
      customHeightField,
      customWidthField
    ].forEach((fieldWrapper) => {
      if (!fieldWrapper) return;

      const showField = fieldWrapper === standardIntendedUseField ? isStandardPillow || isCustomPillow || isXlLumbar : isCustomPillow;

      fieldWrapper.style.display = showField ? 'block' : 'none';
      fieldWrapper.setAttribute('aria-hidden', showField ? 'false' : 'true');

      fieldWrapper.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !showField;

        if (!showField) {
          field.value = '';
        }
      });
    });

    if (isBolster) {
      const intendedUseValue = (bolsterIntentedUseSelect?.value || '').trim().toLowerCase();

      if (intendedUseValue === 'outdoor') {
        setCustomPillowSelectOptions(sizeSelect, 'SELECT SIZE', customPillowBolsterOutdoorSizeOptions, 'bolster-outdoor-size', productTypeChanged);
      } else {
        setCustomPillowSelectOptions(sizeSelect, 'SELECT SIZE', customPillowBolsterSizeOptions, 'bolster-size', productTypeChanged);
      }
    } else if (isSkittle) {
      setCustomPillowSelectOptions(sizeSelect, 'SELECT SIZE', customPillowSkittleSizeOptions, 'skittle-size', productTypeChanged);
    } else if (isStandardPillow) {
      if (standardIntendedUseValue === 'outdoor') {
        setCustomPillowSelectOptions(sizeSelect, 'SELECT SIZE', customPillowStandardOutdoorSizeOptions, 'standard-outdoor-size', productTypeChanged);
      } else {
        setCustomPillowSelectOptions(sizeSelect, 'SELECT SIZE', customPillowStandardSizeOptions, 'standard-size', productTypeChanged);
      }
    } else if (!isOttoman && !isBallPillow && !isXlLumbar && !isCustomPillow) {
      setCustomPillowSelectOptions(sizeSelect, 'SELECT SIZE', customPillowStandardSizeOptions, 'standard-size', productTypeChanged);
    }

    if (edgeFinishSelect) {
      if (isBolster) {
        setCustomPillowSelectOptions(edgeFinishSelect, 'SELECT EDGE FINISH', customPillowBolsterEdgeFinishOptions, 'bolster-edge-finish', productTypeChanged);
      } else if (isSkittle) {
        setCustomPillowSelectOptions(edgeFinishSelect, 'SELECT EDGE FINISH', customPillowSkittleEdgeFinishOptions, 'skittle-edge-finish', productTypeChanged);
      } else if (isXlLumbar) {
        setCustomPillowSelectOptions(edgeFinishSelect, 'SELECT EDGE FINISH', customPillowXlLumbarEdgeFinishOptions, 'xl-lumbar-edge-finish', productTypeChanged);
      } else if (isCustomPillow) {
        setCustomPillowSelectOptions(edgeFinishSelect, 'SELECT EDGE FINISH', customPillowCustomEdgeFinishOptions, 'custom-pillow-edge-finish', productTypeChanged);
      } else {
        setCustomPillowSelectOptions(edgeFinishSelect, 'SELECT EDGE FINISH', customPillowEdgeFinishOptions, 'pillow-edge-finish', productTypeChanged);
      }
    }

    if (edgeFinishField) {
      edgeFinishField.style.display = isOttoman || isBallPillow ? 'none' : 'block';
      edgeFinishField.setAttribute('aria-hidden', isOttoman || isBallPillow ? 'true' : 'false');
    }

    if (edgeFinishSelect) {
      edgeFinishSelect.disabled = isOttoman || isBallPillow;

      if (isOttoman || isBallPillow) {
        edgeFinishSelect.value = '';
      }
    }

    if (addInsertField) {
      addInsertField.style.display = isPillowWithInsertOption ? 'block' : 'none';
      addInsertField.setAttribute('aria-hidden', isPillowWithInsertOption ? 'false' : 'true');
    }

    if (customInsertHint) {
      customInsertHint.hidden = !isCustomPillow;
    }

    if (addInsertSelect) {
      addInsertSelect.disabled = !isPillowWithInsertOption;
      addInsertSelect.required = isPillowWithInsertOption;

      if (!isPillowWithInsertOption) {
        addInsertSelect.value = '';
      } else if (productTypeChanged) {
        addInsertSelect.value = '';
      }
    }

    const showInsertTypeField = isPillowWithInsertOption && !isOutdoorPillow && (addInsertSelect?.value || '').trim().toLowerCase() === 'yes';

    if (insertTypeField) {
      insertTypeField.style.display = showInsertTypeField ? 'block' : 'none';
      insertTypeField.setAttribute('aria-hidden', showInsertTypeField ? 'false' : 'true');
    }

    if (insertTypeSelect) {
      if (isStandardXlLumbarSize) {
        setCustomPillowSelectOptions(insertTypeSelect, 'SELECT INSERT TYPE', customPillowXlLumbarInsertTypeOptions, 'standard-xl-lumbar-insert-type');
      } else {
        setCustomPillowSelectOptions(insertTypeSelect, 'SELECT INSERT TYPE', customPillowInsertTypeOptions, 'standard-insert-type');
      }

      insertTypeSelect.disabled = !showInsertTypeField;
      insertTypeSelect.required = showInsertTypeField;

      if (!showInsertTypeField) {
        insertTypeSelect.value = '';
      }
    }

    if (tapeTrimSelect) {
      if (isBolster) {
        setCustomPillowSelectOptions(tapeTrimSelect, 'CHOOSE ONE', customPillowBolsterTapeTrimOptions, 'bolster-tape-trim', productTypeChanged);
      } else {
        setCustomPillowSelectOptions(tapeTrimSelect, 'CHOOSE ONE', customPillowTapeTrimOptions, 'pillow-tape-trim', productTypeChanged);
      }
    }

    if (tapeTrimRow) {
      tapeTrimRow.style.display = isOttoman || isBallPillow || isSkittle ? 'none' : 'grid';
      tapeTrimRow.setAttribute('aria-hidden', isOttoman || isBallPillow || isSkittle ? 'true' : 'false');
    }

    if (tapeTrimSelect) {
      tapeTrimSelect.disabled = isOttoman || isBallPillow || isSkittle;

      if (isOttoman || isBallPillow || isSkittle) {
        tapeTrimSelect.value = '';
      }
    }

    if (bolsterLengthField) {
      bolsterLengthField.style.display = 'none';
      bolsterLengthField.setAttribute('aria-hidden', 'true');

      bolsterLengthField.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = true;
        field.value = '';
      });
    }

    if (bolsterIntentedUseField) {
      bolsterIntentedUseField.style.display = isBolster ? 'block' : 'none';
      bolsterIntentedUseField.setAttribute('aria-hidden', isBolster ? 'false' : 'true');

      bolsterIntentedUseField.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !isBolster;

        if (!isBolster) {
          field.value = '';
        }
      });
    }

    [
      ottomanTypeField,
      ottomanTrimmingField
    ].forEach((fieldWrapper) => {
      if (!fieldWrapper) return;

      fieldWrapper.style.display = isOttoman ? 'block' : 'none';
      fieldWrapper.setAttribute('aria-hidden', isOttoman ? 'false' : 'true');

      fieldWrapper.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !isOttoman;

        if (!isOttoman) {
          field.value = '';
        }
      });
    });

    const showOttomanTrimmingFabricFields = isOttoman && (ottomanTrimmingSelect?.value || '').trim().toLowerCase() === 'bullion';

    [
      ottomanTrimmingFabricNameField,
      ottomanTrimmingFabricLinkField
    ].forEach((fieldWrapper) => {
      if (!fieldWrapper) return;

      fieldWrapper.style.display = showOttomanTrimmingFabricFields ? 'block' : 'none';
      fieldWrapper.setAttribute('aria-hidden', showOttomanTrimmingFabricFields ? 'false' : 'true');

      fieldWrapper.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !showOttomanTrimmingFabricFields;

        if (!showOttomanTrimmingFabricFields) {
          field.value = '';
        }
      });
    });

    if (bolsterDisclaimer) {
      bolsterDisclaimer.style.display = isBolster ? 'block' : 'none';
      bolsterDisclaimer.setAttribute('aria-hidden', isBolster ? 'false' : 'true');
    }

    if (ottomanDisclaimer) {
      ottomanDisclaimer.style.display = isOttoman ? 'block' : 'none';
      ottomanDisclaimer.setAttribute('aria-hidden', isOttoman ? 'false' : 'true');
    }

    if (ballPillowDisclaimer) {
      ballPillowDisclaimer.style.display = isBallPillow ? 'block' : 'none';
      ballPillowDisclaimer.setAttribute('aria-hidden', isBallPillow ? 'false' : 'true');
    }

    if (xlLumbarDisclaimer) {
      xlLumbarDisclaimer.style.display = isXlLumbar ? 'block' : 'none';
      xlLumbarDisclaimer.setAttribute('aria-hidden', isXlLumbar ? 'false' : 'true');
    }

    if (boxBandRow) {
      boxBandRow.style.display = isBolster || isOttoman || isBallPillow || isSkittle ? 'none' : 'grid';
      boxBandRow.setAttribute('aria-hidden', isBolster || isOttoman || isBallPillow || isSkittle ? 'true' : 'false');
    }

    if (boxBandSelect) {
      boxBandSelect.disabled = isBolster || isOttoman || isBallPillow || isSkittle;

      if (isBolster || isOttoman || isBallPillow || isSkittle) {
        boxBandSelect.value = '';
      }
    }

    if (itemNotesField) {
      itemNotesField.style.display = isBallPillow ? 'none' : 'block';
      itemNotesField.setAttribute('aria-hidden', isBallPillow ? 'true' : 'false');

      itemNotesField.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = isBallPillow;

        if (isBallPillow) {
          field.value = '';
        }
      });
    }

    return true;
  };

  const toggleCustomPillowEdgeFinishFields = (item) => {
    const edgeFinishSelect = item.querySelector('[data-custom-pillow-edge-finish-select]');
    const edgeFinishFields = item.querySelector('[data-custom-pillow-edge-finish-fields]');
    const sameSideWrapper = item.querySelector('[data-custom-pillow-same-side-wrapper]');
    const sameSideCheckbox = item.querySelector('[data-custom-pillow-same-side-checkbox]');
    const ruffleLengthField = item.querySelector('[data-custom-pillow-ruffle-length-field]');
    const skittleBoxBandWidthField = item.querySelector('[data-custom-pillow-skittle-box-band-width-field]');
    const skittleKnifeEdgeDisclaimer = item.querySelector('[data-custom-pillow-skittle-knife-edge-disclaimer]');
    const skittleBoxBandDisclaimer = item.querySelector('[data-custom-pillow-skittle-box-band-disclaimer]');
    const productTypeSelect = item.querySelector('[data-custom-pillow-product-type-select]');

    if (!edgeFinishSelect || !edgeFinishFields) return;

    const edgeFinishValue = (edgeFinishSelect.value || '').trim().toLowerCase();
    const productTypeValue = (productTypeSelect?.value || '').trim().toLowerCase();
    const isBolster = productTypeValue === 'bolster';
    const isSkittle = productTypeValue === 'skittle';
    const isKnifeEdge = edgeFinishValue.startsWith('knife edge');
    const isBolsterSelfCord = isBolster && edgeFinishValue.startsWith('self cord');
    const isSkittleSelfBoxBand = isSkittle && edgeFinishValue.startsWith('self box band');
    const showSameSideField = edgeFinishValue !== '' && !isBolster;
    const showEdgeFinishFields = edgeFinishValue !== '' && !isKnifeEdge && !isBolsterSelfCord && !isSkittleSelfBoxBand;
    const showRuffleLengthField = showEdgeFinishFields && edgeFinishValue.includes('ruffle');
    const showSkittleBoxBandWidthField = isSkittle && edgeFinishValue.includes('box band');
    const showSkittleKnifeEdgeDisclaimer = isSkittle && isKnifeEdge;
    const showSkittleBoxBandDisclaimer = showSkittleBoxBandWidthField;

    if (skittleKnifeEdgeDisclaimer) {
      skittleKnifeEdgeDisclaimer.style.display = showSkittleKnifeEdgeDisclaimer ? 'block' : 'none';
      skittleKnifeEdgeDisclaimer.setAttribute('aria-hidden', showSkittleKnifeEdgeDisclaimer ? 'false' : 'true');
    }

    if (skittleBoxBandDisclaimer) {
      skittleBoxBandDisclaimer.style.display = showSkittleBoxBandDisclaimer ? 'block' : 'none';
      skittleBoxBandDisclaimer.setAttribute('aria-hidden', showSkittleBoxBandDisclaimer ? 'false' : 'true');
    }

    if (sameSideWrapper) {
      sameSideWrapper.style.display = showSameSideField ? 'block' : 'none';
      sameSideWrapper.setAttribute('aria-hidden', showSameSideField ? 'false' : 'true');

      if (showSameSideField) {
        sameSideWrapper.classList.add('custom-pillow-form__same-side-row--visible');
      } else {
        sameSideWrapper.classList.remove('custom-pillow-form__same-side-row--visible');
      }
    }

    if (sameSideCheckbox) {
      sameSideCheckbox.disabled = !showSameSideField;

      if (!showSameSideField) {
        sameSideCheckbox.checked = false;
      }
    }

    edgeFinishFields.style.display = showEdgeFinishFields ? 'grid' : 'none';
    edgeFinishFields.setAttribute('aria-hidden', showEdgeFinishFields ? 'false' : 'true');

    if (showEdgeFinishFields) {
      edgeFinishFields.classList.add('custom-pillow-form__conditional-fields--visible');
    } else {
      edgeFinishFields.classList.remove('custom-pillow-form__conditional-fields--visible');
    }

    edgeFinishFields.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
      field.disabled = !showEdgeFinishFields;

      if (!showEdgeFinishFields) {
        field.value = '';
      }
    });

    if (ruffleLengthField) {
      ruffleLengthField.style.display = showRuffleLengthField ? 'block' : 'none';
      ruffleLengthField.setAttribute('aria-hidden', showRuffleLengthField ? 'false' : 'true');

      ruffleLengthField.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !showRuffleLengthField;

        if (!showRuffleLengthField) {
          field.value = '';
        }
      });
    }

    if (skittleBoxBandWidthField) {
      skittleBoxBandWidthField.style.display = showSkittleBoxBandWidthField ? 'grid' : 'none';
      skittleBoxBandWidthField.setAttribute('aria-hidden', showSkittleBoxBandWidthField ? 'false' : 'true');

      if (showSkittleBoxBandWidthField) {
        skittleBoxBandWidthField.classList.add('custom-pillow-form__conditional-fields--visible');
      } else {
        skittleBoxBandWidthField.classList.remove('custom-pillow-form__conditional-fields--visible');
      }

      skittleBoxBandWidthField.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !showSkittleBoxBandWidthField;

        if (!showSkittleBoxBandWidthField) {
          field.value = '';
        }
      });
    }
  };

  const toggleCustomPillowSameSideFields = (item) => {
    const sameSideCheckbox = item.querySelector('[data-custom-pillow-same-side-checkbox]');
    const reverseFabricFields = item.querySelector('[data-custom-pillow-reverse-fabric-fields]');
    const productTypeSelect = item.querySelector('[data-custom-pillow-product-type-select]');
    const productTypeValue = (productTypeSelect?.value || '').trim().toLowerCase();
    const hideReverseFabricFields = productTypeValue === 'bolster' || productTypeValue === 'ottoman' || productTypeValue === 'ball pillow' || (sameSideCheckbox?.checked === true && !sameSideCheckbox.disabled);

    if (!reverseFabricFields) return;

    reverseFabricFields.style.display = hideReverseFabricFields ? 'none' : 'grid';
    reverseFabricFields.setAttribute('aria-hidden', hideReverseFabricFields ? 'true' : 'false');

    reverseFabricFields.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
      field.disabled = hideReverseFabricFields;

      if (hideReverseFabricFields) {
        field.value = '';
      }
    });
  };

  const toggleCustomPillowTapeTrimFields = (item) => {
    const tapeTrimSelect = item.querySelector('[data-custom-pillow-tape-trim-select]');
    const tapeTrimFields = item.querySelector('[data-custom-pillow-tape-trim-fields]');

    if (!tapeTrimSelect || !tapeTrimFields) return;

    const tapeTrimValue = (tapeTrimSelect.value || '').trim().toLowerCase();
    const showTapeTrimFields = tapeTrimValue !== '' && tapeTrimValue !== 'no trim';
    const showParallelTrimField = showTapeTrimFields && (tapeTrimValue.includes('parallel') || tapeTrimValue.includes('parrallel'));

    tapeTrimFields.style.display = showTapeTrimFields ? 'grid' : 'none';
    tapeTrimFields.setAttribute('aria-hidden', showTapeTrimFields ? 'false' : 'true');

    if (showTapeTrimFields) {
      tapeTrimFields.classList.add('custom-pillow-form__conditional-fields--visible');
    } else {
      tapeTrimFields.classList.remove('custom-pillow-form__conditional-fields--visible');
    }

    tapeTrimFields.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
      field.disabled = !showTapeTrimFields;

      if (!showTapeTrimFields) {
        field.value = '';
      }
    });

    tapeTrimFields.querySelectorAll('[data-custom-pillow-parallel-trim-field]').forEach((fieldWrapper) => {
      fieldWrapper.style.display = showParallelTrimField ? 'block' : 'none';
      fieldWrapper.setAttribute('aria-hidden', showParallelTrimField ? 'false' : 'true');

      fieldWrapper.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        field.disabled = !showParallelTrimField;

        if (!showParallelTrimField) {
          field.value = '';
        }
      });
    });
  };

  const toggleCustomPillowBoxBandFields = (item) => {
    const boxBandRow = item.querySelector('[data-custom-pillow-box-band-row]');
    const boxBandSelect = item.querySelector('[data-custom-pillow-box-band-select]');
    const boxBandFields = item.querySelector('[data-custom-pillow-box-band-fields]');

    if (!boxBandSelect || !boxBandFields) return;

    const boxBandValue = (boxBandSelect.value || '').trim().toLowerCase();
    const showBoxBandRow = !boxBandSelect.disabled;
    const showBoxBandFields = showBoxBandRow && boxBandValue !== '' && boxBandValue !== 'no box band';

    if (boxBandRow) {
      boxBandRow.style.display = showBoxBandRow ? 'grid' : 'none';
      boxBandRow.setAttribute('aria-hidden', showBoxBandRow ? 'false' : 'true');
    }

    boxBandFields.style.display = showBoxBandFields ? 'grid' : 'none';
    boxBandFields.setAttribute('aria-hidden', showBoxBandFields ? 'false' : 'true');

    if (showBoxBandFields) {
      boxBandFields.classList.add('custom-pillow-form__conditional-fields--visible');
    } else {
      boxBandFields.classList.remove('custom-pillow-form__conditional-fields--visible');
    }

    boxBandFields.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
      field.disabled = !showBoxBandFields;

      if (!showBoxBandFields) {
        field.value = '';
      }
    });
  };

  const getCustomPillowSelectedOptionText = (field) => {
    if (field.tagName !== 'SELECT') return '';

    const selectedOption = field.options[field.selectedIndex];
    return selectedOption?.textContent || field.value || '';
  };

  const getCustomPillowPriceFromText = (text) => {
    const prices = String(text || '').match(/\$[0-9]+(?:\.[0-9]{1,2})?/g) || [];
    return prices.reduce((total, price) => total + Number(price.replace('$', '')), 0);
  };

  const formatCustomPillowPrice = (amount) => {
    return `$${amount.toLocaleString('en-US', {
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const customPillowOptionalFieldLabels = new Set([
    'ESTIMATED PRICE',
    'NOTES',
    'SAME SIDED',
    'SIDEMARK',
  ]);

  const getCustomPillowFieldLabel = (field) => {
    const label = field.dataset.fieldLabel || field.closest('.custom-pillow-form__field')?.querySelector('label')?.textContent || 'FIELD';
    return label.trim().replace(/\s+/g, ' ').toUpperCase();
  };

  const getCustomPillowValidationName = (field) => {
    const fieldLabel = getCustomPillowFieldLabel(field);
    const item = field.closest('[data-custom-pillow-item]');
    const itemNumber = item?.querySelector('[data-custom-pillow-item-number]')?.textContent?.trim();

    return itemNumber ? `ITEM ${itemNumber} - ${fieldLabel}` : fieldLabel;
  };

  const shouldValidateCustomPillowField = (field) => {
    if (!field || field.disabled || field.type === 'hidden' || field.type === 'checkbox' || field.type === 'submit') return false;
    if (field.name === 'contact[Sidemark]' || field.name === 'contact[body]') return false;

    return !customPillowOptionalFieldLabels.has(getCustomPillowFieldLabel(field));
  };

  const getCustomPillowValidationFields = (form, scope = form) => {
    const selector = scope === form
      ? '.custom-pillow-form__contact input, [data-custom-pillow-field]'
      : '[data-custom-pillow-field]';

    return Array.from(scope.querySelectorAll(selector));
  };

  const setCustomPillowFieldErrorState = (field, hasError) => {
    const fieldWrapper = field.closest('.custom-pillow-form__field');

    field.classList.toggle('custom-pillow-form__input--error', hasError);
    field.setAttribute('aria-invalid', hasError ? 'true' : 'false');

    if (fieldWrapper) {
      fieldWrapper.classList.toggle('custom-pillow-form__field--error', hasError);
    }
  };

  const syncCustomPillowRequiredFields = (form) => {
    getCustomPillowValidationFields(form).forEach((field) => {
      field.required = shouldValidateCustomPillowField(field);
      field.setCustomValidity('');
      setCustomPillowFieldErrorState(field, false);
    });
  };

  const getCustomPillowFieldError = (field) => {
    if (!shouldValidateCustomPillowField(field)) return '';

    const fieldName = getCustomPillowValidationName(field);

    field.setCustomValidity('');

    if (field.validity.valueMissing) {
      return `PLEASE COMPLETE ${fieldName}.`;
    }

    if (field.validity.typeMismatch) {
      if (field.type === 'email') return `PLEASE ENTER A VALID EMAIL ADDRESS.`;
      if (field.type === 'url') return `PLEASE ENTER A VALID URL FOR ${fieldName}.`;
      return `PLEASE ENTER A VALID VALUE FOR ${fieldName}.`;
    }

    if (field.validity.stepMismatch) {
      if (field.dataset.customPillowWholeNumber === 'true') {
        return `PLEASE ENTER A WHOLE NUMBER FOR ${fieldName}.`;
      }

      return `PLEASE ENTER A VALID VALUE FOR ${fieldName}.`;
    }

    if (field.validity.rangeUnderflow) {
      return `PLEASE ENTER A VALUE OF AT LEAST ${field.min} FOR ${fieldName}.`;
    }

    if (field.validity.rangeOverflow) {
      return `PLEASE ENTER A VALUE OF ${field.max} OR LESS FOR ${fieldName}.`;
    }

    return '';
  };

  const validateCustomPillowForm = (form, showMessage = false, fields = getCustomPillowValidationFields(form)) => {
    const validationError = form.querySelector('[data-custom-pillow-validation-error]');
    const validationErrorText = form.querySelector('[data-custom-pillow-validation-error-text]');
    const fieldStates = fields.map((field) => {
      const message = getCustomPillowFieldError(field);
      field.setCustomValidity(message);
      return { field, message };
    });
    const fieldErrors = fieldStates.filter((fieldError) => fieldError.message);
    const shouldShowMessage = showMessage || (validationError && !validationError.hidden);

    fieldStates.forEach((fieldState) => {
      setCustomPillowFieldErrorState(fieldState.field, shouldShowMessage && fieldState.message !== '');
    });

    if (fieldErrors.length && validationError && validationErrorText && shouldShowMessage) {
      validationErrorText.replaceChildren();

      if (fieldErrors.length === 1) {
        validationErrorText.textContent = fieldErrors[0].message;
      } else {
        const messageIntro = document.createElement('p');
        const fieldList = document.createElement('ul');

        messageIntro.textContent = 'PLEASE COMPLETE THESE FIELDS:';

        fieldErrors.forEach((fieldError) => {
          const fieldListItem = document.createElement('li');
          fieldListItem.textContent = getCustomPillowValidationName(fieldError.field);
          fieldList.appendChild(fieldListItem);
        });

        validationErrorText.append(messageIntro, fieldList);
      }

      validationError.hidden = false;
    } else if (validationError) {
      validationErrorText?.replaceChildren();
      validationError.hidden = true;
    }

    return {
      isValid: fieldErrors.length === 0,
      firstInvalidField: fieldErrors[0]?.field,
    };
  };

  const isCustomPillowDraftEnabled = (form) => {
    return form.dataset.customPillowDraftEnabled === 'true' && form.dataset.customPillowCustomerId;
  };

  const getCustomPillowDraftKey = (form) => {
    return `custom-pillow-form-draft:${form.dataset.customPillowCustomerId}:${window.location.pathname}`;
  };

  const getCustomPillowDraftFormKey = () => {
    return window.location.pathname;
  };

  const getCustomPillowDraftBasePath = (form) => {
    const fallbackPath = '/apps/wishlist-1/custom-pillow-draft';
    const formAction = form.getAttribute('action') || '';

    try {
      const actionUrl = new URL(formAction, window.location.origin);
      return actionUrl.pathname.replace(/\/custom-pillow-form$/, '/custom-pillow-draft') || fallbackPath;
    } catch (error) {
      return fallbackPath;
    }
  };

  const getCustomPillowDraftEndpoint = (form, path = '') => {
    const params = new URLSearchParams({
      form_key: getCustomPillowDraftFormKey(),
    });

    return `${getCustomPillowDraftBasePath(form)}${path}?${params.toString()}`;
  };

  const readCustomPillowLocalDraft = (form) => {
    try {
      return JSON.parse(window.localStorage.getItem(getCustomPillowDraftKey(form)) || 'null');
    } catch (error) {
      window.localStorage.removeItem(getCustomPillowDraftKey(form));
      return null;
    }
  };

  const writeCustomPillowLocalDraft = (form, draftData) => {
    try {
      window.localStorage.setItem(getCustomPillowDraftKey(form), JSON.stringify(draftData));
      return true;
    } catch (error) {
      return false;
    }
  };

  const removeCustomPillowLocalDraft = (form) => {
    window.localStorage.removeItem(getCustomPillowDraftKey(form));
  };

  const fetchCustomPillowServerDraft = async (form) => {
    if (!isCustomPillowDraftEnabled(form)) return null;

    const response = await window.fetch(getCustomPillowDraftEndpoint(form), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(data.error || 'Draft could not be loaded.');
    }

    return data.draft || null;
  };

  const saveCustomPillowServerDraft = async (form, draftData) => {
    if (!isCustomPillowDraftEnabled(form)) return null;

    const response = await window.fetch(getCustomPillowDraftEndpoint(form), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        formKey: getCustomPillowDraftFormKey(),
        draft: draftData,
      }),
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(data.error || 'Draft could not be saved.');
    }

    return data.draft || draftData;
  };

  const clearCustomPillowServerDraft = async (form) => {
    if (!isCustomPillowDraftEnabled(form)) return false;

    const response = await window.fetch(getCustomPillowDraftEndpoint(form, '/clear'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        formKey: getCustomPillowDraftFormKey(),
      }),
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(data.error || 'Draft could not be cleared.');
    }

    return true;
  };

  const showCustomPillowDraftFeedback = (form, message) => {
    const draftFeedback = form.querySelector('[data-custom-pillow-draft-feedback]');
    const draftFeedbackText = form.querySelector('[data-custom-pillow-draft-feedback-text]');
    if (!draftFeedback) return;

    if (draftFeedbackText) {
      draftFeedbackText.textContent = message;
    } else {
      draftFeedback.textContent = message;
    }

    draftFeedback.hidden = false;

    window.clearTimeout(form.customPillowDraftFeedbackTimeout);
    form.customPillowDraftFeedbackTimeout = window.setTimeout(() => {
      draftFeedback.hidden = true;
    }, 3500);
  };

  const resetCustomPillowItemFields = (item) => {
    item.querySelectorAll('input, select, textarea').forEach((field) => {
      field.setCustomValidity?.('');
      field.removeAttribute('aria-invalid');
      field.classList.remove('custom-pillow-form__input--error');
      field.closest('.custom-pillow-form__field')?.classList.remove('custom-pillow-form__field--error');

      if (field.type === 'checkbox') {
        field.checked = false;
        field.value = field.getAttribute('value') || 'YES';
      } else if (field.dataset.fieldLabel === 'QUANTITY') {
        field.value = '1';
      } else if (field.type !== 'hidden') {
        field.value = '';
      }
    });
  };

  const cloneCustomPillowItem = (sourceItem) => {
    const newItem = sourceItem.cloneNode(true);
    resetCustomPillowItemFields(newItem);
    return newItem;
  };

  const findCustomPillowItemField = (item, fieldId) => {
    return Array.from(item.querySelectorAll('[data-custom-pillow-field]')).find((field) => {
      return field.dataset.fieldId === fieldId;
    });
  };

  const setCustomPillowFieldValue = (field, fieldData) => {
    if (!field) return;

    const productTypeDraftValue = String(fieldData.value || '').trim().toUpperCase();
    const fieldValue = field.dataset.fieldId?.includes('customPillowProductType') && (productTypeDraftValue === 'PILLOW' || productTypeDraftValue === 'PILLOW (STANDARD)')
      ? 'PILLOW (STANDARD SIZES)'
      : field.dataset.fieldId?.includes('customPillowProductType') && productTypeDraftValue === 'PILLOW (CUSTOM)'
        ? 'PILLOW (CUSTOM SIZES)'
        : fieldData.value || '';

    if (field.type === 'checkbox') {
      field.checked = Boolean(fieldData.checked);
      field.value = field.getAttribute('value') || fieldValue || 'YES';
      return;
    }

    field.value = fieldValue;
  };

  const getCustomPillowDraftData = (form) => {
    const contactFields = Array.from(form.querySelectorAll('[name="contact[name]"], [name="contact[email]"], [name="contact[Sidemark]"], [name="contact[body]"]')).map((field) => {
      return {
        name: field.name,
        value: field.value || '',
      };
    });
    const items = Array.from(form.querySelectorAll('[data-custom-pillow-item]')).map((item) => {
      return {
        fields: Array.from(item.querySelectorAll('[data-custom-pillow-field]')).filter((field) => {
          return !field.hasAttribute('data-custom-pillow-estimate-input');
        }).map((field) => {
          return {
            fieldId: field.dataset.fieldId,
            value: field.value || '',
            checked: field.type === 'checkbox' ? field.checked : undefined,
          };
        }),
      };
    });

    return {
      savedAt: new Date().toISOString(),
      contactFields,
      items,
    };
  };

  const saveCustomPillowDraft = async (form) => {
    if (!isCustomPillowDraftEnabled(form)) return false;

    updateCustomPillowForm(form);
    const draftData = getCustomPillowDraftData(form);
    const localDraftSaved = writeCustomPillowLocalDraft(form, draftData);

    try {
      const syncedDraft = await saveCustomPillowServerDraft(form, draftData);

      if (syncedDraft) {
        writeCustomPillowLocalDraft(form, syncedDraft);
      }

      showCustomPillowDraftFeedback(form, 'DRAFT SAVED.');
      return true;
    } catch (error) {
      showCustomPillowDraftFeedback(
        form,
        localDraftSaved
          ? 'DRAFT SAVED ON THIS DEVICE. CROSS-DEVICE SYNC FAILED.'
          : 'DRAFT COULD NOT BE SAVED.'
      );
      return localDraftSaved;
    }
  };

  const resetCustomPillowDraftFields = (form) => {
    form.querySelectorAll('[name="contact[name]"], [name="contact[email]"], [name="contact[Sidemark]"], [name="contact[body]"]').forEach((field) => {
      field.value = '';
      field.setCustomValidity?.('');
      field.removeAttribute('aria-invalid');
      field.closest('.custom-pillow-form__field')?.classList.remove('custom-pillow-form__field--error');
    });

    const itemsContainer = form.querySelector('[data-custom-pillow-items]');
    const firstItem = itemsContainer?.querySelector('[data-custom-pillow-item]');

    if (itemsContainer && firstItem) {
      itemsContainer.querySelectorAll('[data-custom-pillow-item]').forEach((item, index) => {
        if (index > 0) item.remove();
      });

      resetCustomPillowItemFields(firstItem);
    }

    updateCustomPillowForm(form);
    validateCustomPillowForm(form);
  };

  const clearCustomPillowDraft = async (form, showMessage = true, resetFields = true) => {
    if (!isCustomPillowDraftEnabled(form)) return;

    removeCustomPillowLocalDraft(form);

    if (resetFields) {
      resetCustomPillowDraftFields(form);
    }

    try {
      await clearCustomPillowServerDraft(form);

      if (showMessage) {
        showCustomPillowDraftFeedback(form, 'DRAFT CLEARED.');
      }
    } catch (error) {
      if (showMessage) {
        showCustomPillowDraftFeedback(form, 'DRAFT CLEARED ON THIS DEVICE. CROSS-DEVICE CLEAR FAILED.');
      }
    }
  };

  const applyCustomPillowDraft = (form, itemsContainer, draft) => {
    if (!isCustomPillowDraftEnabled(form)) return;

    if (!draft?.items?.length) return;

    draft.contactFields?.forEach((fieldData) => {
      const field = Array.from(form.querySelectorAll('[name]')).find((formField) => formField.name === fieldData.name);
      if (field) field.value = fieldData.value || '';
    });

    const firstItem = itemsContainer.querySelector('[data-custom-pillow-item]');
    if (!firstItem) return;

    itemsContainer.querySelectorAll('[data-custom-pillow-item]').forEach((item, index) => {
      if (index > 0) item.remove();
    });

    resetCustomPillowItemFields(firstItem);

    while (itemsContainer.querySelectorAll('[data-custom-pillow-item]').length < draft.items.length) {
      itemsContainer.appendChild(cloneCustomPillowItem(firstItem));
    }

    const restoredItems = Array.from(itemsContainer.querySelectorAll('[data-custom-pillow-item]'));

    draft.items.forEach((itemData, index) => {
      const item = restoredItems[index];
      const productTypeField = itemData.fields.find((fieldData) => {
        return String(fieldData.fieldId || '').includes('customPillowProductType');
      });

      if (productTypeField) {
        setCustomPillowFieldValue(findCustomPillowItemField(item, productTypeField.fieldId), productTypeField);
      }
    });

    updateCustomPillowForm(form);

    draft.items.forEach((itemData, index) => {
      const item = restoredItems[index];

      itemData.fields.forEach((fieldData) => {
        setCustomPillowFieldValue(findCustomPillowItemField(item, fieldData.fieldId), fieldData);
      });
    });

    updateCustomPillowForm(form);

    draft.items.forEach((itemData, index) => {
      const item = restoredItems[index];

      itemData.fields.forEach((fieldData) => {
        setCustomPillowFieldValue(findCustomPillowItemField(item, fieldData.fieldId), fieldData);
      });
    });

    updateCustomPillowForm(form);
    validateCustomPillowForm(form);
  };

  const restoreCustomPillowDraft = async (form, itemsContainer) => {
    if (!isCustomPillowDraftEnabled(form)) return;

    let draft = null;

    try {
      draft = await fetchCustomPillowServerDraft(form);

      if (draft?.items?.length) {
        writeCustomPillowLocalDraft(form, draft);
      }
    } catch (error) {
      draft = readCustomPillowLocalDraft(form);
    }

    if (!draft?.items?.length) {
      draft = readCustomPillowLocalDraft(form);
    }

    if (!draft?.items?.length) return;

    applyCustomPillowDraft(form, itemsContainer, draft);
    showCustomPillowDraftFeedback(form, 'DRAFT LOADED.');
  };

  const updateCustomPillowEstimatedPrice = (item) => {
    const estimateText = item.querySelector('[data-custom-pillow-estimate-text]');
    const estimateInput = item.querySelector('[data-custom-pillow-estimate-input]');
    const productTypeSelect = item.querySelector('[data-custom-pillow-product-type-select]');
    const productTypeValue = (productTypeSelect?.value || '').trim().toLowerCase();
    const quantityInput = item.querySelector('[data-field-label="QUANTITY"]');
    const quantity = Math.max(Number(quantityInput?.value || 1) || 1, 1);
    const sizeSelect = item.querySelector('[data-custom-pillow-size-select]');
    const edgeFinishSelect = item.querySelector('[data-custom-pillow-edge-finish-select]');
    const addInsertSelect = item.querySelector('[data-custom-pillow-add-insert-select]');
    const insertTypeSelect = item.querySelector('[data-custom-pillow-insert-type-select]');
    const edgeFinishValue = (edgeFinishSelect?.value || '').trim().toLowerCase();
    const addInsertValue = (addInsertSelect?.value || '').trim().toLowerCase();
    const insertTypeValue = (insertTypeSelect?.value || '').trim().toLowerCase();
    const isStandardPillow = productTypeValue === 'pillow' || productTypeValue === 'pillow (standard)' || productTypeValue === 'pillow (standard sizes)';
    const isCustomPillow = productTypeValue === 'pillow (custom)' || productTypeValue === 'pillow (custom sizes)';
    const isXlLumbar = productTypeValue === 'xl lumbar' || productTypeValue === 'xl lumbar 14" x 48"';
    const basePrice = isXlLumbar && edgeFinishValue !== '' && !edgeFinishValue.startsWith('knife edge')
      ? 160
      : customPillowBasePrices[productTypeValue] || 0;
    const standardIntendedUseSelect = item.querySelector('[data-custom-pillow-standard-intended-use-field] [data-custom-pillow-field]');
    const standardIntendedUseValue = (standardIntendedUseSelect?.value || '').trim().toLowerCase();
    const isOutdoorPillow = (isStandardPillow || isCustomPillow || isXlLumbar) && standardIntendedUseValue === 'outdoor';
    const hasOutdoorInsertEstimate = isOutdoorPillow && ((isStandardPillow || isCustomPillow) ? addInsertValue === 'yes' : isXlLumbar);
    const insertPricesBySize = insertTypeValue === 'feather down'
      ? customPillowFeatherDownInsertPricesBySize
      : customPillowDownAlternativeInsertPricesBySize;
    const insertPrice = isStandardPillow && !isOutdoorPillow && addInsertValue === 'yes'
      && (insertTypeValue === 'feather down' || insertTypeValue === 'down alternative')
      ? insertPricesBySize[sizeSelect?.value] || 0
      : 0;
    const optionPrice = Array.from(item.querySelectorAll('select[data-custom-pillow-field]')).reduce((total, field) => {
      if (field.disabled) return total;
      if (isXlLumbar && field === edgeFinishSelect) return total;
      return total + getCustomPillowPriceFromText(getCustomPillowSelectedOptionText(field));
    }, 0);
    const estimateEach = basePrice + optionPrice + insertPrice;
    const estimateValue = hasOutdoorInsertEstimate
      ? 'PRICE TBD'
      : estimateEach > 0
      ? `${formatCustomPillowPrice(estimateEach)} EACH${quantity > 1 ? ` / ${formatCustomPillowPrice(estimateEach * quantity)} TOTAL` : ''}`
      : 'PRICE TBD';

    if (estimateText) {
      estimateText.textContent = estimateValue;
    }

    if (estimateInput) {
      estimateInput.value = estimateValue;
    }

    return {
      hasEstimate: !hasOutdoorInsertEstimate && estimateEach > 0,
      hasUnknownEstimate: hasOutdoorInsertEstimate,
      total: estimateEach * quantity,
    };
  };

  const updateCustomPillowForm = (form) => {
    const summaryInput = form.querySelector('[data-custom-pillow-summary]');
    const orderEstimateText = form.querySelector('[data-custom-pillow-order-estimate-text]');
    const orderEstimateInput = form.querySelector('[data-custom-pillow-order-estimate-input]');
    const items = Array.from(form.querySelectorAll('[data-custom-pillow-item]'));
    let hasOrderEstimate = false;
    let hasUnknownOrderEstimate = false;
    let orderEstimateTotal = 0;

    items.forEach((item, index) => {
      const itemNumber = index + 1;
      const numberElement = item.querySelector('[data-custom-pillow-item-number]');
      const removeButton = item.querySelector('[data-remove-custom-pillow-item]');
      const emailItemHeading = item.querySelector('[data-custom-pillow-email-item-heading]');
      const productTypeSelect = item.querySelector('[data-custom-pillow-product-type-select]');

      if (numberElement) numberElement.textContent = itemNumber;
      if (removeButton) removeButton.hidden = items.length === 1;
      if (emailItemHeading) {
        emailItemHeading.name = `contact[---------- ITEM ${itemNumber} ----------]`;
        emailItemHeading.value = productTypeSelect?.value || 'NO PRODUCT TYPE SELECTED';
      }

      const hasProductType = toggleCustomPillowProductTypeFields(item);

      if (hasProductType) {
        toggleCustomPillowEdgeFinishFields(item);
        toggleCustomPillowSameSideFields(item);
        toggleCustomPillowTapeTrimFields(item);
        toggleCustomPillowBoxBandFields(item);
      }

      const itemEstimate = updateCustomPillowEstimatedPrice(item);

      if (itemEstimate?.hasUnknownEstimate) {
        hasUnknownOrderEstimate = true;
      }

      if (itemEstimate?.hasEstimate) {
        hasOrderEstimate = true;
        orderEstimateTotal += itemEstimate.total;
      }

      item.querySelectorAll('[data-custom-pillow-field]').forEach((field) => {
        const fieldLabel = field.dataset.fieldLabel || 'Field';
        field.name = `contact[ITEM ${itemNumber} - ${fieldLabel}]`;
        const fieldId = `${field.dataset.fieldId}--${itemNumber}`;
        const label = field.closest('.custom-pillow-form__field')?.querySelector('[data-custom-pillow-label]');

        field.id = fieldId;
        if (label) label.setAttribute('for', fieldId);
      });
    });

    const orderEstimateValue = hasUnknownOrderEstimate
      ? 'PRICE TBD'
      : hasOrderEstimate
      ? formatCustomPillowPrice(orderEstimateTotal)
      : 'PRICE TBD';

    if (orderEstimateText) {
      orderEstimateText.textContent = orderEstimateValue;
    }

    if (orderEstimateInput) {
      orderEstimateInput.value = orderEstimateValue;
    }

    syncCustomPillowRequiredFields(form);

    if (!summaryInput) return;

    summaryInput.value = items.map((item, index) => {
      const details = Array.from(item.querySelectorAll('[data-custom-pillow-field]')).filter((field) => {
        return !field.disabled;
      }).map((field) => {
        if (field.type === 'checkbox') {
          return `${field.dataset.fieldLabel}: ${field.checked ? 'YES' : 'NO'}`;
        }

        return `${field.dataset.fieldLabel}: ${field.value || ''}`;
      });

      return `ITEM ${index + 1}: ${details.join(', ')}`;
    }).join('\n');
  };

  const showCustomPillowSubmissionStatus = (form) => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get('custom_pillow_form');
    const successMessage = form.querySelector('[data-custom-pillow-success]');
    const errorMessage = form.querySelector('[data-custom-pillow-error]');

    if (status === 'success') {
      clearCustomPillowDraft(form, false, false);
    }

    if (successMessage) {
      successMessage.hidden = status !== 'success';

      if (status === 'success') {
        successMessage.setAttribute('tabindex', '-1');
        successMessage.focus({ preventScroll: true });
      }
    }

    if (errorMessage) errorMessage.hidden = status !== 'error';

    return status;
  };

  const initCustomPillowForm = (form) => {
    const itemsContainer = form.querySelector('[data-custom-pillow-items]');
    const addButton = form.querySelector('[data-add-custom-pillow-item]');
    const saveDraftButton = form.querySelector('[data-save-custom-pillow-draft]');
    const clearDraftButton = form.querySelector('[data-clear-custom-pillow-draft]');
    const closeDraftFeedbackButton = form.querySelector('[data-custom-pillow-draft-feedback-close]');

    if (!itemsContainer || !addButton) return;

    form.noValidate = true;

    const successMessage = form.querySelector('[data-custom-pillow-success]');
    const closeSuccessButtons = form.querySelectorAll('[data-custom-pillow-success-close]');

    closeSuccessButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (successMessage) successMessage.hidden = true;
      });
    });

    if (successMessage) {
      successMessage.addEventListener('click', (event) => {
        if (event.target === successMessage) successMessage.hidden = true;
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && successMessage && !successMessage.hidden) {
        successMessage.hidden = true;
      }
    });

    addButton.addEventListener('click', () => {
      const firstItem = itemsContainer.querySelector('[data-custom-pillow-item]');
      if (!firstItem) return;

      updateCustomPillowForm(form);

      const currentItems = Array.from(itemsContainer.querySelectorAll('[data-custom-pillow-item]'));
      const lastItem = currentItems[currentItems.length - 1];
      const validation = validateCustomPillowForm(form, true, getCustomPillowValidationFields(form, lastItem));

      if (!validation.isValid) {
        validation.firstInvalidField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        validation.firstInvalidField?.focus({ preventScroll: true });
        return;
      }

      const newItem = cloneCustomPillowItem(firstItem);

      itemsContainer.appendChild(newItem);
      updateCustomPillowForm(form);
      validateCustomPillowForm(form);
    });

    saveDraftButton?.addEventListener('click', () => {
      saveCustomPillowDraft(form);
    });

    clearDraftButton?.addEventListener('click', () => {
      clearCustomPillowDraft(form);
    });

    closeDraftFeedbackButton?.addEventListener('click', () => {
      const draftFeedback = form.querySelector('[data-custom-pillow-draft-feedback]');
      window.clearTimeout(form.customPillowDraftFeedbackTimeout);
      if (draftFeedback) draftFeedback.hidden = true;
    });

    itemsContainer.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-custom-pillow-item]');
      if (!removeButton) return;

      const item = removeButton.closest('[data-custom-pillow-item]');
      if (!item || itemsContainer.querySelectorAll('[data-custom-pillow-item]').length === 1) return;

      item.remove();
      updateCustomPillowForm(form);
      validateCustomPillowForm(form);
    });

    itemsContainer.addEventListener('change', (event) => {
      const conditionalInput = event.target.closest('[data-custom-pillow-product-type-select], [data-custom-pillow-edge-finish-select], [data-custom-pillow-tape-trim-select], [data-custom-pillow-box-band-select], [data-custom-pillow-same-side-checkbox], [data-custom-pillow-add-insert-select]');
      if (!conditionalInput) return;

      const item = conditionalInput.closest('[data-custom-pillow-item]');
      if (!item) return;

      updateCustomPillowForm(form);
      validateCustomPillowForm(form);
    });

    form.addEventListener('input', () => {
      updateCustomPillowForm(form);
      validateCustomPillowForm(form);
    });

    form.addEventListener('change', () => {
      updateCustomPillowForm(form);
      validateCustomPillowForm(form);
    });

    form.addEventListener('submit', (event) => {
      updateCustomPillowForm(form);

      const validation = validateCustomPillowForm(form, true);

      if (!validation.isValid) {
        event.preventDefault();
        validation.firstInvalidField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        validation.firstInvalidField?.focus({ preventScroll: true });
      }
    });

    updateCustomPillowForm(form);
    const submissionStatus = showCustomPillowSubmissionStatus(form);

    if (submissionStatus !== 'success') {
      restoreCustomPillowDraft(form, itemsContainer);
    }

    validateCustomPillowForm(form);
  };

  const initCustomPillowForms = (container = document) => {
    container.querySelectorAll('.custom-pillow-form').forEach((form) => {
      if (form.dataset.customPillowFormInitialized === 'true') return;

      form.dataset.customPillowFormInitialized = 'true';
      initCustomPillowForm(form);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCustomPillowForms());
  } else {
    initCustomPillowForms();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCustomPillowForms(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
